module.exports = __webpack_public_path__ + "img/magafaim_yes.5ba8b148.png";